import { nothing, svg } from 'lit';
import { Legends } from '../legend/Legends.js';
import { legendsConfiguration } from '../legend/types.js';
import { highlightStateProvider, margin, size } from '../types.js';
import { KeyScale } from '../axis/key/KeyScale.js';
import { boundsKeyAxis, boundsLeftAxis, boundsLegends, boundsPlotArea } from '../bounds.js';
import { DomainBaseline } from '../axis/value/DomainBaseline.js';
import { ValueScale } from '../axis/value/ValueScale.js';
import { KeyAxis } from '../axis/key/KeyAxis.js';
import { KeyHoverBands } from '../axis/key/KeyHoverBands.js';
import { OneUxPlotChartElement } from '../OneUxPlotChartElement.js';
export function ChartEmptyContent(this: OneUxPlotChartElement, {
  legendsConfiguration,
  svgSize,
  animate,
  svgMargin,
  keyScale,
  highlightStateProvider
}: {
  legendsConfiguration: legendsConfiguration;
  svgSize: size;
  svgMargin: margin;
  keyScale: KeyScale;
  animate: boolean;
  highlightStateProvider: highlightStateProvider;
}) {
  return svg`
  ${this.hideLegends ? nothing : Legends({
    legendsConfiguration,
    bounds: boundsLegends(svgSize, svgMargin),
    series: this.series,
    animate,
    onLegendMouseEnter: this._onLegendMouseEnter,
    onLegendMouseLeave: this._onLegendMouseLeave,
    highlightStateProvider
  })}
  ${DomainBaseline({
    bounds: boundsPlotArea(svgSize, svgMargin),
    valueScale: new ValueScale(boundsLeftAxis(svgSize, svgMargin), 0, 1),
    animate
  })}
  ${KeyAxis({
    bounds: boundsKeyAxis(svgSize, svgMargin),
    keyScale,
    animate
  })}
  ${KeyHoverBands({
    bounds: boundsPlotArea(svgSize, svgMargin),
    keyScale,
    onKeyHoverBandMouseEnter: this._onKeyHoverBandMouseEnter,
    onKeyHoverBandMouseLeave: this._onKeyHoverBandMouseLeave
  })}`;
}